import {
  Alert,
  AlertTypography,
  Button,
  Icon,
  Link,
  Modal,
  ModalActionButton,
  ModalActions,
  ModalCloseIconButton,
  ModalContent,
  ModalTitle,
  Typography,
  Progress,
} from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../state/state';
import { sources } from '../api/sources';
import { useHistory } from 'react-router-dom';
import { Pages } from '../utils/constants';
import wallet from '../assets/Wallet.svg';
import { useState } from 'react';
import { UtagHelper, UtagType } from '../utils/UtagHelper';

export const LimitReachedModal = ({ open, onClose }: { open: boolean; onClose: any }) => {
  const history = useHistory();
  const [memberDetails] = useGlobalState('memberDetails');
  const [finishLoadingProps, setFinishLoadingProps] = useState({ finished: true, onFinish: () => {} });
  const [tags] = useGlobalState('tags');
  const [isLimitTagging, setLimitTagging] = useState(true);

  if (open && isLimitTagging) {
    UtagHelper.sendTag(UtagType.view, tags, 'plastic request limit', {});
    setLimitTagging(false);
  }
  function onCloseModal() {
    setLimitTagging(true);
    onClose();
  }

  function isEligibleIOS() {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) &&
      memberDetails.loggedInCustomerId === memberDetails.selectedCustomerId
    );
  }
  function isEligibleAndroid() {
    return /Android/.test(navigator.userAgent) && memberDetails.loggedInCustomerId === memberDetails.selectedCustomerId;
  }

  const onRequestAppleWallet = async () => {
    UtagHelper.sendTag(UtagType.link, tags, 'plastic request limit', {
      cta: 'my account:account maintenance:replacement card:plastic request limit-add to wallet',
    });
    setFinishLoadingProps({ finished: false, onFinish: () => {} });
    const response = await sources.getAppleWallet();
    setFinishLoadingProps({ finished: true, onFinish: () => {} });

    if (response && response.status == 'success' && response?.data) {
      try {
        const pkPass = response?.data;
        const binaryData = atob(pkPass); // Decode base64 to binary string
        const byteArray = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
          byteArray[i] = binaryData.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: 'application/vnd.apple.pkpass' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'Membership.pkpass';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        history.push(Pages.SorryPage);
      }
    } else {
      history.push(Pages.SorryPage);
    }
  };
  const onRequestAndroidWallet = async () => {
    UtagHelper.sendTag(UtagType.link, tags, 'plastic request limit', {
      cta: 'my account:account maintenance:replacement card:plastic request limit-add to wallet',
    });
    setFinishLoadingProps({ finished: false, onFinish: () => {} });
    const response = await sources.getAndroidWallet();
    setFinishLoadingProps({ finished: true, onFinish: () => {} });
    if (response && response.status == 'success' && response?.data) {
      try {
        const pkPass = response?.data;
        const binaryData = atob(pkPass); // Decode base64 to binary string
        const wallet = JSON.parse(binaryData);
        const walletUrl = wallet?.saveToWalletUrl;

        const a = document.createElement('a');
        a.href = walletUrl;
        a.target = '_blank';

        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(walletUrl);
      } catch (error) {
        history.push(Pages.SorryPage);
      }
    } else {
      history.push(Pages.SorryPage);
    }
  };
  return (
    <>
      <Modal
        id="replacement-card-modal"
        open={open}
        size="small"
        onClose={onCloseModal}
        sx={{
          '& .MuiDialogPaperVariant-bottom-sheet': {
            minHeight: '0 !important',
          },
        }}
        variants={{
          xs: 'bottom-sheet',
          sm: 'bottom-sheet',
          md: 'regular',
          lg: 'regular',
          xl: 'regular',
        }}
      >
        <ModalTitle
          id="modal-title"
          className="replacement-card-modal-title"
          sx={{ marginRight: '2rem', display: 'flex', fontSize: '20px', fontWeight: '700' }}
        >
          You've reached your limit
          <ModalCloseIconButton id="modal-close-btn" aria-label="Close" onClick={onCloseModal} />
        </ModalTitle>

        <ModalContent id="modal-content">
          <Typography className="replacement-card-modal-description" variant="b2Regular" sx={{ marginBottom: '1rem' }}>
            If you have requested a plastic replacement card, please wait 7 days before submitting another request.
            There is a limit of 2 requests for a plastic replacement card each membership year. For assistance, please
            call us.
          </Typography>
          <Alert
            sx={{ backgroundColor: '#E9F7DB' }}
            severity="success"
            displayCloseButton={false}
            icon={<Icon iconName="leaf-regular" className="replace-card-alert-icon" />}
          >
            <AlertTypography variant="regular" className="replacement-card-banner-message" sx={{ padding: '0 0.5rem' }}>
              <strong>Download your digital membership card</strong> today to access your benefits anytime, anywhere!
            </AlertTypography>
          </Alert>
          <ModalActions
            sx={{ flexDirection: 'column !important', rowGap: '0.5rem' }}
            actionLayout={{
              sm: 'fullWidth',
              md: 'fullWidth',
              lg: 'fullWidth',
              xl: 'fullWidth',
            }}
          >
            <Button
              visible={isEligibleAndroid}
              className="download-android-wallet-button"
              label={
                <>
                  <img src={wallet} className="wallet-image" alt="icon" />
                  <Typography sx={{ color: '#FFF', fontWeight: '500', backgroundColor: '#000' }}>
                    {'  '}
                    Add to Google Wallet
                  </Typography>
                </>
              }
              fullWidth
              sx={{
                backgroundColor: '#000',
                borderColor: '#A6A6A6',
                ':hover': { backgroundColor: '#000' },
              }}
              onClick={onRequestAndroidWallet}
            ></Button>
            <Button
              visible={isEligibleIOS()}
              className="download-apple-wallet-button"
              label={
                <>
                  <img src={wallet} className="wallet-image" alt="icon" />
                  <Typography sx={{ color: '#FFF', fontWeight: '500', backgroundColor: '#000' }}>
                    {'  '}
                    Add to Apple Wallet
                  </Typography>
                </>
              }
              fullWidth
              sx={{
                marginTop: '1.5rem',
                backgroundColor: '#000',
                borderColor: '#A6A6A6',
                ':hover': { backgroundColor: '#000' },
              }}
              onClick={() => onRequestAppleWallet()}
            ></Button>

            <ModalActionButton
              variant="outlined"
              className="replacement-card-modal-call-us"
              label={
                <Link sx={{ textDecoration: 'none' }} target="_blank" href="tel:+18887030678">
                  Call 1-888-703-0678
                </Link>
              }
            />
          </ModalActions>
          {!finishLoadingProps.finished && <Progress variant="circular" />}
        </ModalContent>
      </Modal>
    </>
  );
};
